import React from "react";
import Chat from "../components/common/Chat";
import Toolbar from "../navigation/Toobar";
import Header from "../layout/Header";

function VipCoin(){
  return(
    <div className="v-application--wrap">
  <div>
    <div className="row no-gutters">
      <Header/>
    </div>
    <div className="body">
      <div>
        <div className="row no-gutters">
          <div className="depo-with-mobile-header text-left col col-12">
            <button type="button" className="v-icon notranslate bank-mobile-header-navArrow v-icon--link mdi mdi-chevron-left theme--dark" style={{fontSize: '36px'}} />
            <span className="align-center justify-center" style={{textTransform: 'uppercase'}}>VIP Membership Details</span>
          </div>
        </div>
        <div className="row tier-level-row no-gutters">
          <div className="v-tabs tier-tab theme--dark" grows>
            <div role="tablist" className="v-item-group theme--dark v-slide-group v-slide-group--is-overflowing v-tabs-bar v-tabs-bar--is-mobile primary--text" data-booted="true">
              <div className="v-slide-group__prev v-slide-group__prev--disabled">{/**/}</div>
              <div className="v-slide-group__wrapper">
                <div className="v-slide-group__content v-tabs-bar__content">
                  <div className="v-tabs-slider-wrapper" style={{height: '2px', left: '0px', width: '90px'}}><div className="v-tabs-slider" /></div>
                  <div tabIndex={0} aria-selected="true" role="tab" className="v-tab v-tab--active">
                    Newbie
                  </div>
                  <div tabIndex={0} aria-selected="false" role="tab" className="v-tab">
                    Junior
                  </div>
                  <div tabIndex={0} aria-selected="false" role="tab" className="v-tab">
                    Senior
                  </div>
                  <div tabIndex={0} aria-selected="false" role="tab" className="v-tab">
                    Elite
                  </div>
                  <div tabIndex={0} aria-selected="false" role="tab" className="v-tab">
                    Master
                  </div>
                  <div tabIndex={0} aria-selected="false" role="tab" className="v-tab">
                    Grand Master
                  </div>
                  <div tabIndex={0} aria-selected="false" role="tab" className="v-tab">
                    Big Boss
                  </div>
                </div>
              </div>
              <div className="v-slide-group__next v-slide-group__next--disabled">{/**/}</div>
            </div>
          </div>
          <div className="v-window v-item-group theme--dark v-tabs-items">
            <div className="v-window__container" style={{}}>
              <div className="v-window-item v-window-item--active">
                <div className="v-image v-responsive theme--dark">
                  <div className="v-responsive__sizer" style={{paddingBottom: '44.4444%'}} />
                  <div className="v-image__image v-image__image--cover" style={{backgroundImage: 'url("./static/image/viptier/detailsBanner_newbie_en.jpg")', backgroundPosition: 'center center'}} />
                  <div className="v-responsive__content" style={{width: '1080px'}} />
                </div>
                <div className="tierdetail-divWrapper">
                  <div className="tierDetail-card v-card v-sheet v-sheet--outlined theme--dark">
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>VIP Level</span></div>
                      <div className="col-padding col col-4"><span>Newbie</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Deposit Upgrade Requirement</span></div>
                      <div className="col-padding col col-4"><span>None</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Turnover Upgrade Requirement</span></div>
                      <div className="col-padding col col-4"><span>None</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>VIP Upgrade Bonus</span></div>
                      <div className="col-padding col col-4"><span>None</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Auto Deposit Bonus %</span></div>
                      <div className="col-padding col col-4"><span>3.50%</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Birthday Bonus</span></div>
                      <div className="col-padding col col-4"><span>৳188</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Deposit Coin %</span></div>
                      <div className="col-padding col col-4"><span>1.00%</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Slots Daily Turnover Rebate (%)</span></div>
                      <div className="col-padding col col-4"><span>0.50%</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Casino Table Turnover Rebate (%)</span></div>
                      <div className="col-padding col col-4"><span>0.30%</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Crash Games Turnover Rebate (%)</span></div>
                      <div className="col-padding col col-4"><span>0.30%</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>VIP Merchandise &amp; Special Gifts</span></div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>label.csSupport</span></div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Deposit &amp; Withdrawal Priority</span></div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>VIP Events &amp; Experiences</span></div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Exclusive Access to New Features</span></div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Dedicated VIP Manager</span></div>
                      <div className="col-padding col col-4">{/**/}</div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-padding col col-12" style={{textAlign: 'center'}}><span>Maintenance Requirements</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Monthly Deposit Required</span></div>
                      <div className="col-padding col col-4"><span>None</span></div>
                    </div>
                    <div className="row row-border no-gutters">
                      <div className="col-border col col-8"><span>Monthly Turnover Required</span></div>
                      <div className="col-padding col col-4"><span>None</span></div>
                    </div>
                    <div className="row no-gutters">
                      <div className="col-border col col-8"><span>Membership Renewal</span></div>
                      <div className="col-padding col col-4"><span>Lifetime</span></div>
                    </div>
                  </div>
                </div>
              </div>
              {/**/}{/**/}{/**/}{/**/}{/**/}{/**/}
            </div>
          </div>
        </div>
      </div>
      {/**/}
    </div>
    <Toolbar/>
    <Chat/>
  </div>
</div>

  );
}
export default VipCoin;